import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { IDataProducto, IServicioDigital } from '../interfaces';
import { IUbicacionProducto } from '../interfaces/erp/inventario';
import CustomCantidadInput from '../components/ui/CustomCantidadInput';
import { IStockFactorSerie } from '../interfaces/erp/administration/productofactorserie.interface';
import { useCargarSeriesProductos } from '@/store/erp/productos/useCargarSeriesProductos.store';
import { renderEmpty } from '../utils/renderEmpty';
import { toast } from 'react-toastify';
import { cellNotFilter, emptyCellObject } from '../utils';
import ModalObservacionGeneral from '../components/ui/ModalObservacionesGeneral';

export const useTableColumnsProducto = () => {
  const columnsCheckMovimientoInventario = useMemo<
    MRT_ColumnDef<IUbicacionProducto>[]
  >(
    () => [
      {
        id: 'producto',
        accessorKey: 'codigo',
        header: 'codigo',
        size: 150,
        Cell: ({ row }) => `${row.original.producto_data?.codigo}`
      },
      {
        accessorKey: 'descripcion_producto',
        header: 'Descripción',
        size: 150,
        Cell: ({ row }) => `${row.original.producto_data?.descripcion}`
      },
      {
        ...cellNotFilter,
        accessorKey: 'stock_actual',
        header: 'stock',
        size: 100,
        Cell: ({ row }) =>
          row.original.producto_data?.usa_metros
            ? `${row.original.metros_actuales} (METROS)`
            : row.original.stock
      },

      {
        ...cellNotFilter,
        accessorKey: 'categoria_producto',
        header: 'Categoria',
        size: 150,
        Cell: ({ row }) => emptyCellObject(row.original.producto_data, 'categoria_producto')
      },
      {
        ...cellNotFilter,
        accessorKey: 'unidad_medida',
        header: 'Unidad',
        size: 150,
        Cell: ({ row }) => `${row.original.producto_data?.unidad_medida || "UNIDADES"}`
      },
      {
        ...cellNotFilter,
        accessorKey: 'recurrencia_compra',
        header: 'Recurrencia compra',
        size: 150,
        Cell: ({ row }) => `${row.original.producto_data?.recurrencia_compra}`

      },
    ],
    []
  );


  const columnsCheckMovimientoInventarioTecnico = useMemo<
    MRT_ColumnDef<IUbicacionProducto>[]
  >(
    () => [
      {
        id: 'producto',
        accessorKey: 'codigo',
        header: 'codigo',
        size: 110,
        Cell: ({ row }) => `${row.original.producto_data?.codigo}`
      },
      {
        accessorKey: 'descripcion_producto',
        header: 'Descripción',
        size: 190,
        Cell: ({ row }) => `${row.original.producto_data?.descripcion}`
      },
      {
        ...cellNotFilter,
        accessorKey: 'categoria_producto',
        header: 'Categoria',
        size: 150,
        Cell: ({ row }) => emptyCellObject(row.original.producto_data, 'categoria_producto')
      },
      {
        ...cellNotFilter,
        accessorKey: 'unidad_medida',
        header: 'Unidad',
        size: 150,
        Cell: ({ row }) => `${row.original.producto_data?.unidad_medida || "UNIDADES"}`
      },
      {
        ...cellNotFilter,
        accessorKey: 'recurrencia_compra',
        header: 'Recurrencia compra',
        size: 150,
        Cell: ({ row }) => `${row.original.producto_data?.recurrencia_compra}`

      },
    ],
    []
  );

  const columnsSelectProductoModal = useMemo<MRT_ColumnDef<IDataProducto>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Codigo',
        size: 150,
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        Cell: ({ row }) => {
          return row.original?.descripcion || 'N/A'
        },
        size: 150,
      },
      {
        accessorKey: 'categoria_producto',
        header: 'Categoria Producto',
        size: 150,
        Cell: ({ row }) => renderEmpty(row.original?.categoria_producto)
      },
      {
        accessorKey: 'unidad_medida',
        header: 'Unidad Medida',
        size: 150,
        Cell: ({ row }) => renderEmpty(row.original?.unidad_medida)
      },
      {
        accessorKey: 'recurrencia_compra',
        header: 'Recurrencia Compra',
        size: 150,
      },
    ],
    []
  );

  //COLUMNA DE SERIES CARGADO POR ARCHIVO
  const columnsCargarSeries = useMemo(
    () => [
      {
        id: 'numero_serie',
        header: 'Número Serie',
        accessorFn: (str: string) => str,
        size: 425,
      },
      //{
      //  id: 'cantidad_metros',
      //  header: 'Cantidad',
      //  accessorFn: (str: string) => str,
      //},
    ],
    []
  );

  ///* Renderizar en recepcion de transferencia
  const columnsProductoFactorRecepcion = useMemo<MRT_ColumnDef<{ cantidad_metros: string }>[]>(
    () => [
      {
        id: 'serie',
        accessorKey: 'serie',
        header: 'Número Serie',
      },
      {
        id: 'cantidad_metros',
        accessorKey: 'cantidad_metros',
        header: 'Cantidad',
        Cell: ({ row }) => `${row.original.cantidad_metros} (METROS)`

      },
    ],
    []
  );

  ///* Carga manual de un producto por metros (reingreso): como factor, mas la
  ///* observacion. Las series que vinieron de TXT/Excel no traen metros ("—").
  const columnsProductMetroSeries = useMemo<MRT_ColumnDef<IStockFactorSerie>[]>(
    () => [
      {
        id: 'serie',
        accessorKey: 'serie',
        header: 'Número Serie',
      },
      {
        id: 'cantidad_metros',
        accessorKey: 'cantidad_metros',
        header: 'Cantidad',
        Cell: ({ row }) => row.original.cantidad_metros ? `${row.original.cantidad_metros} (METROS)` : '—'
      },
      {
        id: 'observacion',
        accessorKey: 'observacion',
        header: 'Observación',
        Cell: ({ row }) => row.original.observacion || '—'
      },
    ],
    []
  );

  ///* Equipos Adicional
  const columnsEquipoAdicional = useMemo<MRT_ColumnDef<IDataProducto>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        size: 150,
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        size: 150,
      },
    ],
    []
  );

  ///* Equipos Adicional
  const columnsEquipoAdicionalUbicacion = useMemo<MRT_ColumnDef<IDataProducto>[]>(
    () => [
      {
        accessorKey: 'producto',
        header: 'Código',
        size: 150,
        Cell: ({ row }: { row: any }) => row.original?.producto_data?.codigo || 'N/A'
      },
      {
        accessorKey: 'descripcion_producto',
        header: 'Descripción',
        size: 150,
        Cell: ({ row }: { row: any }) => row.original?.producto_data?.descripcion || 'N/A'
      },
      {
        accessorKey: 'cantidad',
        header: 'Stock',
        size: 150,
        enableColumnFilter: false,
      },
    ],
    []
  );


  ///* seleccionar series y producto asociado

  const handleActualizarProductoFactor = useCargarSeriesProductos(s => s.handleActualizarProductoFactor)


  const columnsProductoAsociado = useMemo<MRT_ColumnDef<IStockFactorSerie>[]>(
    () => [
      {
        id: 'serie',
        accessorKey: 'serie',
        header: 'Número Serie',
        size: 425,
      },
      /* {
        id: 'id',
        accessorKey: 'id',
        header: 'id',
      }, */
      {
        id: 'peso_factor',
        accessorKey: 'peso_factor',
        header: 'Disponible',
      },
      {
        accessorKey: "cantidad_metros",
        header: "Cantidad",
        size: 125,
        Cell: ({ row }) => (
          <CustomCantidadInput<IStockFactorSerie>
            value={row.original.cantidad_metros ?? '0'}
            handleValue={(value) => {

              if (+row.original.peso_factor >= +value) {
                handleActualizarProductoFactor(row.original.id, {
                  ...row.original,
                  cantidad_metros: value ?? '0'
                })
                return
              } else {
                toast.info('Cantidad no disponible.')
              }

            }}
            row={row}
          />
        ),
      }], []
  )
  const columnsProductoAsociadoTecnico = useMemo<MRT_ColumnDef<IStockFactorSerie>[]>(
    () => [
      {
        id: 'serie',
        accessorKey: 'serie',
        header: 'Número Serie',
        size: 425,
      },
      /* {
        id: 'id',
        accessorKey: 'id',
        header: 'id',
      }, */
      {
        accessorKey: "cantidad_metros",
        header: "Cantidad",
        size: 125,
        Cell: ({ row }) => (
          <CustomCantidadInput<IStockFactorSerie>
            value={row.original.cantidad_metros ?? '0'}
            handleValue={(value) => {

              if (+row.original.peso_factor >= +value) {
                handleActualizarProductoFactor(row.original.id, {
                  ...row.original,
                  cantidad_metros: value ?? '0'
                })
                return
              } else {
                toast.info('Cantidad no disponible.')
              }

            }}
            row={row}
          />
        ),
      }], []
  )
  const columnsSelectServicioDigitalModal = useMemo<MRT_ColumnDef<IServicioDigital>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Codigo',
        size: 150,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        Cell: ({ row }) => {
          return row.original?.nombre || 'N/A'
        },
        size: 150,
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        size: 100,
        Cell: ({ row }) => (
          <ModalObservacionGeneral
            texto={row.original?.descripcion || 'N/A'}
            title='Descripción'
            titleModal='Descripción'
          />
        )
      },
      /*  {
         accessorKey: 'descripcion',
         header: 'Descripción',
         Cell: ({ row }) => {
           console.log('row',row.original)
           return row.original?.descripcion || 'N/A'
         },
         size: 150,
       }, */
      {
        accessorKey: 'categoria_producto',
        header: 'Categoria Producto',
        size: 150,
      },
    ],
    []
  );

  return {
    columnsCheckMovimientoInventario,
    columnsCheckMovimientoInventarioTecnico,
    columnsSelectProductoModal,
    columnsCargarSeries,
    columnsEquipoAdicional,
    columnsEquipoAdicionalUbicacion,
    columnsProductoAsociado,
    columnsProductoAsociadoTecnico,
    columnsProductoFactorRecepcion,
    columnsProductMetroSeries,
    columnsSelectServicioDigitalModal,
  };
};
